import { Show } from 'solid-js'
import { useCountdown } from '~/hooks/use-countdown'
import { m } from '~/paraglide/messages'
import { EventCountdownFrame } from './graphics/countdown-frame'

function pad(n: number): string {
  return String(n).padStart(2, '0')
}

function Chip(props: { value: number; label: string }) {
  return (
    <div class="relative size-[97px]">
      <EventCountdownFrame />
      <div class="absolute inset-0 flex flex-col items-center justify-center">
        <span class="text-[36px] font-bold">{pad(props.value)}</span>
        <span class="mt-[2px] font-semibold">{props.label}</span>
      </div>
    </div>
  )
}

export function CountdownSection() {
  const countdown = useCountdown()
  return (
    <Show when={!countdown().done}>
      <div class="flex w-full items-center justify-center gap-[10px] py-3 text-white">
        <Chip value={countdown().days} label={m.day()} />
        <span class="text-[25px]">:</span>
        <Chip value={countdown().hours} label={m.hour()} />
        <span class="text-[25px]">:</span>
        <Chip value={countdown().minutes} label={m.min()} />
      </div>
    </Show>
  )
}
